var HttpCodes = {
	KO: 0,
	OK: 200,
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500
};

module.exports = HttpCodes;


// WEBPACK FOOTER //
// ./src/enums/HttpCodes.js